<template>
  <div class="row justify-content-center">
    <div id="plda-content" class="row justify-content-center mb-5 col-md-10">
      <div id="plda-content" class="row justify-content-center mb-1 col-md-10">
        <p
          class="row fts-22 mb-3 h-emphasis light-blue-01"
          style="font-weight: 900; text-decoration: underline"
        >
          Partie 1
        </p>
      </div>
      <div id="plda-content" class="row justify-content-center mb-1 col-md-10">
        <p class="fts-18 mb-3 h-emphasis" style="font-weight: 600">
          Définissez vos critères
        </p>
      </div>
      <table class="myfotable-dark mb-7" style="width: 100%">
        <colgroup>
          <col style="width: 50%" />
          <col style="width: 50%" />
        </colgroup>
        <thead class="plda-top-dashboard">
          <tr>
            <th>Investissement (€)</th>
            <th>Horizon de placement (ans)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type="number"
                class="form-control-seo step-3"
                style="font-style: italic; margin-left: 10px"
                placeholder="Ex. 10000"
                v-model="amount"
                :name="'form[amount]'"
              />
            </td>
            <td>
              <input
                type="number"
                class="form-control-seo step-3"
                style="font-style: italic; margin-left: 10px"
                placeholder="Ex. 5"
                v-model="year"
                :name="'form[year]'"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mt-5 justify-content-center text-center">
        <a
          class="btn-alt-2 mb-3"
          style="cursor: pointer"
          v-b-modal="modalId('portfeuille')"
        >
          Votre portefeuille actuel
          <span style="color: #ff0000; font-size: 20px">
            {{ sec.length }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="currentColor"
            class="bi bi-plus-circle ml-1"
            style="margin-bottom: 2px"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
            />
          </svg>
        </a>
      </div>
      <b-modal
        title="Votre portefeuille"
        class="modal fade alt-list"
        :id="'modal' + 'portfeuille'"
        tabindex="-1"
        role="dialog"
        size="xl"
        aria-labelledby="alternatives"
        aria-hidden="true"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant"
        :body-bg-variant="bodyBgVariant"
        :body-text-variant="bodyTextVariant"
        :footer-bg-variant="footerBgVariant"
        :footer-text-variant="footerTextVariant"
        ok-only
      >
        <div>
          <form method="POST" :action="route">
            <input type="hidden" name="_token" :value="token" />
            <input type="hidden" :name="'form[year]'" :value="year" />
            <input type="hidden" :name="'form[amount]'" :value="amount" />
            <table class="myfotable-dark">
              <colgroup>
                <col style="width: 16.6%" />
                <col style="width: 16.6%" />
                <col style="width: 16.6%" />
                <col style="width: 16.6%" />
              </colgroup>
              <thead class="plda-top-dashboard">
                <tr>
                  <th>Nom de l'ETF</th>
                  <th>ISIN</th>
                  <th>Score Impact</th>
                  <th>Score Performeur</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(alt, i) in sec" :key="i">
                  <input
                    type="hidden"
                    :name="'form[' + i + '][id]'"
                    :value="alt.id"
                  />
                  <div style="display: contents" id="random">
                    <td
                      style="
                        font-weight: bold;
                        color: rgb(187, 134, 252);
                        text-align: left;
                      "
                    >
                      {{ alt.name }}
                      <input
                        type="hidden"
                        style="font-size: 11px"
                        :name="'form[' + i + '][name]'"
                        :value="alt.name"
                      />
                    </td>
                    <td style="font-weight: bold; color: rgb(187, 134, 252)">
                      {{ alt.isin }}
                      <input
                        type="hidden"
                        style="font-size: 11px"
                        :name="'form[' + i + '][isin]'"
                        :value="alt.isin"
                      />
                    </td>
                    <td style="font-weight: bold; color: rgb(187, 134, 252)">
                      {{ alt.esg_score_aggregated }}
                    </td>
                    <td style="font-weight: bold; color: rgb(187, 134, 252)">
                      {{ alt.sharpe_ratio.toFixed(2) }}
                    </td>
                  </div>
                </tr>
              </tbody>
            </table>
            <div class="m-4 justify-content-center text-center">
              <button type="submit" class="btn-alt-2 m-2 triggerspinner">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-arrow-clockwise mr-1"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                  />
                  <path
                    d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                  />
                </svg>
                Optimiser mon portefeuille
              </button>
            </div>
          </form>
        </div>
      </b-modal>
      <b-modal
        title="Votre portefeuille"
        class="modal fade alt-list"
        :id="'modal' + 'portfeuille'"
        tabindex="-1"
        role="dialog"
        size="xl"
        aria-labelledby="alternatives"
        aria-hidden="true"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant"
        :body-bg-variant="bodyBgVariant"
        :body-text-variant="bodyTextVariant"
        :footer-bg-variant="footerBgVariant"
        :footer-text-variant="footerTextVariant"
        ok-only
      >
        <div>
          <form method="POST" :action="route">
            <input type="hidden" name="_token" :value="token" />
            <input type="hidden" :name="'form[year]'" :value="year" />
            <input type="hidden" :name="'form[amount]'" :value="amount" />
            <table class="myfotable-dark">
              <colgroup>
                <col style="width: 16.6%" />
                <col style="width: 16.6%" />
                <col style="width: 16.6%" />
                <col style="width: 16.6%" />
              </colgroup>
              <thead class="plda-top-dashboard">
                <tr>
                  <th>Position</th>
                  <th>ISIN</th>
                  <th>Score climat</th>
                  <th>Ratio Sharpe</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(alt, i) in sec" :key="i">
                  <input
                    type="hidden"
                    :name="'form[' + i + '][id]'"
                    :value="alt.id"
                  />
                  <div style="display: contents" id="random">
                    <td
                      style="
                        font-weight: bold;
                        color: rgb(187, 134, 252);
                        text-align: left;
                      "
                    >
                      {{ alt.name }}
                      <input
                        type="hidden"
                        style="font-size: 11px"
                        :name="'form[' + i + '][name]'"
                        :value="alt.name"
                      />
                    </td>
                    <td style="font-weight: bold; color: rgb(187, 134, 252)">
                      {{ alt.isin }}
                      <input
                        type="hidden"
                        style="font-size: 11px"
                        :name="'form[' + i + '][isin]'"
                        :value="alt.isin"
                      />
                    </td>
                    <td style="font-weight: bold; color: rgb(187, 134, 252)">
                      {{ alt.esg_score_aggregated }}
                    </td>
                    <td style="font-weight: bold; color: rgb(187, 134, 252)">
                      {{ Math.round(alt.sharpe_ratio * 100) / 100 }}
                    </td>
                  </div>
                </tr>
              </tbody>
            </table>
            <div class="m-4 justify-content-center text-center">
              <button type="submit" class="btn-alt-2 m-2 triggerspinner">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-arrow-clockwise mr-1"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                  />
                  <path
                    d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                  />
                </svg>
                Optimiser mon portefeuille
              </button>
            </div>
          </form>
        </div>
      </b-modal>
    </div>
    <div id="plda-content" class="row justify-content-center mb-1 col-md-10">
      <p
        class="row fts-22 mb-3 h-emphasis light-blue-01"
        style="font-weight: 900; text-decoration: underline"
      >
        Partie 2
      </p>
    </div>
    <div id="plda-content" class="row justify-content-center mb-1 col-md-10">
      <p class="fts-18 mb-3 h-emphasis" style="font-weight: 600">
        Ajouter des ETF à votre portefeuille à l'aide des filtres proposés
      </p>
    </div>
    <table class="myfotable-dark mb-4" style="width: 100%">
      <tbody>
        <tr
          v-for="(project, index) in projs"
          :key="index"
          style="border-bottom: 1px solid rgba(30, 30, 30, 0.1)"
        >
          <input
            type="hidden"
            :name="'form[' + index + '][id]'"
            :value="project.id"
          />
          <td style="vertical-align: middle; width: 24%">
            <select
              class="form-control-4 mx-auto"
              style="font-size: 11px; width: 50%; text-transform: capitalize"
              v-model="asset_class"
            >
              <option value="null" disabled>
                Selectionner la classe d'actifs
              </option>
              <option
                v-for="asset_class in assets"
                :key="asset_class.id"
                :value="asset_class"
              >
                {{ asset_class.name_french }}
              </option>
            </select>
            <input
              v-if="asset_class != null"
              type="hidden"
              style="font-size: 11px"
              :name="'form[' + index + '][asset_class_id]'"
              :value="asset_class.id"
            />
            <a
              style="
                background-color: transparent;
                border: none;
                cursor: pointer;
              "
              class="h-emphasis mx-2"
              v-b-modal="modalId('asset')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                class="mb-1 bi bi-info-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#ff6a00"
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill="#ff6a00"
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                />
              </svg>
            </a>
            <b-modal
              title="Information sur les classes d'actifs"
              class="modal fade alt-list"
              :id="'modal' + 'asset'"
              tabindex="-1"
              role="dialog"
              aria-labelledby="alternatives"
              aria-hidden="true"
              :header-bg-variant="headerBgVariant"
              :header-text-variant="headerTextVariant"
              :body-bg-variant="bodyBgVariant"
              :body-text-variant="bodyTextVariant"
              :footer-bg-variant="footerBgVariant"
              :footer-text-variant="footerTextVariant"
              ok-only
            >
              <div>
                <p class="py-2 light-white-03" style="text-align: justify">
                  Sur myfo vous retrouverez les princiaples classe d'actifs telles que : <br />- Les actions<br />- Les obligations <br />- Le monétaire<br />- Alternatif (ensemble des autres classe d'actif)<br />
                  <br />
                  Investir sur différentes classes d'actifs vous permet de diversifier votre portefeuille et ainsi diminuer votre risque.
                </p>
              </div>
            </b-modal>
          </td>
          <td class="py-3 px-2" style="vertical-align: middle; width: 24%">
            <select
              class="form-control-4 mx-auto"
              style="font-size: 11px; width: 50%; text-transform: capitalize"
              v-model="sector"
            >
              <option value="null" disabled>Selectionner le secteur</option>
              <option
                v-for="sector in filteredSector(asset_class)"
                :key="sector.id"
                :value="sector"
              >
                {{ sector.name_french }}
              </option>
            </select>
            <input
              v-if="project.sector != null"
              type="hidden"
              :name="'form[' + index + '][client_category_id]'"
              :value="project.sector.id"
            />
            <a
              style="
                background-color: transparent;
                border: none;
                cursor: pointer;
              "
              class="h-emphasis mx-2"
              v-b-modal="modalId('secteurs')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                class="mb-1 bi bi-info-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#ff6a00"
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill="#ff6a00"
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                />
              </svg>
            </a>
            <b-modal
              title="Information sur les secteurs disponibles"
              class="modal fade alt-list"
              :id="'modal' + 'secteurs'"
              tabindex="-1"
              role="dialog"
              aria-labelledby="alternatives"
              aria-hidden="true"
              :header-bg-variant="headerBgVariant"
              :header-text-variant="headerTextVariant"
              :body-bg-variant="bodyBgVariant"
              :body-text-variant="bodyTextVariant"
              :footer-bg-variant="footerBgVariant"
              :footer-text-variant="footerTextVariant"
              ok-only
            >
              <div>
                <p class="py-2 light-white-03" style="text-align: justify">
                  Un ETF suit la performance d'un ensemble de valeurs qui sont
                  réparties selon différentes thématiques bien précises.<br />
                  <br />
                  Ainsi, sur myfo, vous retrouverez des ETF répartis sur des
                  centaines de secteurs.<br />
                  <br />
                  Vous retrouverez par exemple les secteurs suivants :<br /><br />
                  - Biotechnologie et Santé<br />- Matières Premières<br />-
                  Energie<br />- Actions croissance Europe<br />- Global :
                  Ensemble des plus grosses capitalisations mondiales<br />-
                  Or<br />- Obligations vertes<br />
                  <br />
                  Et plus de 200 autres !
                </p>
              </div>
            </b-modal>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="myfotable-dark" style="width: 100%">
      <thead class="plda-top-dashboard">
        <tr>
          <th style="text-align: left">Nom de l'ETF</th>
          <th style="text-align: left">
            Score Impact
            <a
              style="
                background-color: transparent;
                border: none;
                cursor: pointer;
              "
              class="h-emphasis"
              v-b-modal="modalId('climat')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                class="mb-1 bi bi-info-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#ff6a00"
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill="#ff6a00"
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                />
              </svg>
            </a>
            <b-modal
              title="Information sur notre score IMPACT"
              class="modal fade alt-list"
              :id="'modal' + 'climat'"
              tabindex="-1"
              role="dialog"
              aria-labelledby="alternatives"
              aria-hidden="true"
              :header-bg-variant="headerBgVariant"
              :header-text-variant="headerTextVariant"
              :body-bg-variant="bodyBgVariant"
              :body-text-variant="bodyTextVariant"
              :footer-bg-variant="footerBgVariant"
              :footer-text-variant="footerTextVariant"
              ok-only
            >
              <div>
                <p class="py-2 light-white-03" style="text-align: justify">
                  Le score IMPACT correspond à l'impact du fond sur notre
                  société.<br />
                  <br />
                  Plus le score est proche de 100 plus le fond finance des
                  entreprises avec un impact positif sur notre environnement.<br />
                  Ce score a été calculé en calculant la moyenne pondéré des
                  scores attribués à chacune des entreprises comprises dans
                  l'ETF.<br />
                  <br />
                  Parmi les critères pris en compte dans le calcul des scores,
                  nous retrouvons : <br />
                  <br />
                  <span style="text-decoration: underline">
                    Critères Environnementaux
                  </span>
                  : Taux d'émission de CO2 / Taux d'utilisation ou de production
                  d'énergie verte / Taux de recyclage des déchets / Prévention
                  des risques (marées noires,contamination, déjection)<br />
                  <span style="text-decoration: underline"
                    >Critères Sociaux :</span
                  >
                  Taux de représentation Homme-Femme / Emploi des personnes
                  handicapés / Prévention des risques / Formation interne /
                  Respect du droit des employés.<br />
                  <span style="text-decoration: underline"
                    >Critères de Gouvernance :</span
                  >
                  Transparence de la rémunération / Indépendance des conseils
                  d'administration / Comité de vérification des comptes / Lutte
                  contre la corruption.<br />
                  <br />
                  Pour plus d'information sur ce score, lisez notre article
                  <a href="/notre-vue-des-marchés">ici</a>
                </p>
              </div>
            </b-modal>
          </th>
          <th style="text-align: left">
            Score Performeur 1Y
            <a
              style="
                background-color: transparent;
                border: none;
                cursor: pointer;
              "
              class="h-emphasis"
              v-b-modal="modalId('sharpe')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                class="mb-1 bi bi-info-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#ff8800"
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill="#ff8800"
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                />
              </svg>
            </a>
            <b-modal
              title="Information sur notre score PERFORMEUR"
              class="modal fade alt-list"
              :id="'modal' + 'sharpe'"
              tabindex="-1"
              role="dialog"
              aria-labelledby="alternatives"
              aria-hidden="true"
              :header-bg-variant="headerBgVariant"
              :header-text-variant="headerTextVariant"
              :body-bg-variant="bodyBgVariant"
              :body-text-variant="bodyTextVariant"
              :footer-bg-variant="footerBgVariant"
              :footer-text-variant="footerTextVariant"
              ok-only
            >
              <div>
                <p class="py-2 light-white-03" style="text-align: justify">
                  Le score PERFOMEUR témoigne de la performance financière du
                  fond relatif au risque encourru. Ce score est calculé à partir
                  du ratio de Sharpe qui mesure lui-même l'écart de rentabilité
                  entre un portefeuille et un référentiel (placement sans
                  risque).<br />
                  <br />
                  Plus notre score est élevé plus l'ETF a performé.<br />
                  <br />
                  - Si le score est inférieur à 1, le sur-rendement de l'ETF
                  comparé à un investissement sans risque (EURIBOR 3 mois) se
                  fait pour une prise de risque trop élevée.<br />
                  <br />
                  - Si le score est supérieur à 1, l'ETF dégage une rentabilité
                  très satisfaisante par rapport au risque encourru.<br />
                  <br />
                  Pour plus d'information sur ce score, lisez notre article
                  <a href="/notre-vue-des-marchés">ici</a>
                </p>
              </div>
            </b-modal>
          </th>
          <th style="text-align: left">Ajouter au portefeuille</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(project, index) in filteredSecurity(sector, asset_class)"
          :key="index"
          style="border-bottom: 1px solid rgba(30, 30, 30, 0.1)"
        >
          <input
            type="hidden"
            :name="'form[' + index + '][id]'"
            :value="project.id"
          />
          <td
            class="py-3 px-2"
            style="
              font-weight: bold;
              color: #635bff;
              vertical-align: middle;
              width: 24%;
              font-size: 15px;
            "
          >
            {{ project.name }}
          </td>
          <td
            class="py-3 px-2"
            style="
              font-weight: bold;
              color: #635bff;
              vertical-align: middle;
              width: 24%;
              font-size: 15px;
            "
          >
            {{ project.esg_score_aggregated }}
          </td>
          <td
            class="py-3 px-2"
            style="
              font-weight: bold;
              color: #635bff;
              vertical-align: middle;
              width: 24%;
              font-size: 15px;
            "
          >
            {{ Math.round(project.sharpe_ratio * 100) / 100 }}
          </td>
          <td class="py-3 px-2" style="font-size: 15px">
            <input
              id="track"
              :name="'form[' + index + '][select]'"
              v-model="sec"
              type="checkbox"
              class="form-check-input"
              :value="project"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      align="center"
      :data="securities"
      @pagination-change-page="list"
    ></pagination>
  </div>
</template>

<script>
import pagination from "laravel-vue-pagination";
export default {
  props: ["securities", "asset_classes", "sectors", "token", "route"],
  components: {
    pagination
  },
  data() {
    return {
      form: [],
      secs: [],
      sects: [],
      projs: [],
      assets: [],
      amount: 10000,
      year: 5,
      sector: this.sectors[0],
      asset_class: this.asset_classes[0],
      sec: [],
      variants: [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
        "light",
        "dark"
      ],
      headerBgVariant: "info",
      headerTextVariant: "light",
      bodyBgVariant: "dark",
      bodyTextVariant: "dark",
      footerBgVariant: "info",
      footerTextVariant: "dark",
      pageSize: 10,
      currentPage: 1
    };
  },

  mounted() {
    this.securities.forEach(security => {
      this.secs.push(security);
      if (!this.assets.find(element => element.id == security.asset_class.id)) {
        this.assets.push(security.asset_class);
      }
      if (!this.sects.find(element => element.id == security.sector.id)) {
        this.sects.push(security.sector);
      }
    });

    this.assets.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    this.secs.sort((a, b) => {
      if (a.esg_score_aggregated > b.esg_score_aggregated) return -1;
      if (a.esg_score_aggregated < b.esg_score_aggregated) return 1;
      return 0;
    });

    this.sects.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
    this.addRaw();
  },

  computed: {
    total() {
      var tot = 0;
      this.projs.forEach(project => {
        if (project.security != null) {
          tot += project.security.esg_score_aggregated;
        }
      });
      return tot;
    }
  },

  methods: {
    filteredSecurity(sector, asset_class) {
      if (asset_class != null && sector != null) {
        console.log(sector);
        return this.secs
          .filter(s => s.sector.name === sector.name)
          .filter(s => s.asset_class.name === asset_class.name);
      } else {
        return [];
      }
    },

    filteredSector(asset_class) {
      if (asset_class != null) {
        var sector = [];
        console.log(asset_class);
        this.secs
          .filter(s => s.asset_class.name === asset_class.name)
          .forEach(security => {
            if (!sector.find(element => element.id == security.sector.id)) {
              sector.push(security.sector);
            }
          });
        return sector;
      }
    },

    modalId(i) {
      return "modal" + i;
    },

    addRaw() {
      this.projs.push({
        id: null,
        asset_class: null,
        sector: null,
        security: null,
        esg_score_aggregated: 0
      });
    }
  }
};
</script>

<style scoped>
.pagination {
  margin-bottom: 0;
}
</style>